/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ExperienceAddToIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Experience Add To',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20 26h-8v-4h8v-2h-8v-4h16v2h4V3a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h19ZM4 6h24v8H4Zm6 20H4V16h6Z"
    />
    <path
      d="m35.394 29.051-3.837-3.837 4.3-4.363A.5.5 0 0 0 35.5 20H22v13.494a.5.5 0 0 0 .854.358l4.33-4.265 3.837 3.837a1 1 0 0 0 1.414 0l2.96-2.959a1 1 0 0 0-.001-1.414Z"
    />
  </svg>`;
};
